import classNames from "classnames";
import React from "react";
import VatNumberDetailsCard from "./VatNumberDetailsCard";

interface Props {
  companyId: number
  euVatNumber: server.dto.EuVatNumber
  displayDot?: boolean
  hideRefresh?: boolean
}

const VatNumberDetails = (props: Props) => {
  const { companyId } = props;

  const [isRefreshing, setIsRefreshing] = React.useState(false);
  const [hasFinishedRefreshing, setHasFinishedRefreshing] = React.useState(false);
  const [hasFinishedFadingOut, setHasFinishedFadingOut] = React.useState(false);
  const [euVatNumber, setVatNumber] = React.useState(props.euVatNumber);

  const canRefresh = (euVatNumber.number != null && euVatNumber.isEuMember && euVatNumber.viesValidationOutcome !== "formattingError") && !hasFinishedFadingOut && !props.hideRefresh;

  const refresh = async () => {
    if (isRefreshing || hasFinishedRefreshing) return;

    setIsRefreshing(true);

    try {
      const vatCheckResult = await window.CoreApi.EuVatNumber.RecheckCompanyVatNumber(companyId);
      setVatNumber(vatCheckResult.data);
      setHasFinishedRefreshing(true);
    } catch (e) {
      console.error(e);
    } finally {
      setIsRefreshing(false);
    }
  };

  const reloadClasses = classNames("icon-reload small", {
    rotating: isRefreshing,
    "fade-out-rotating": hasFinishedRefreshing
  });

  const onAnimationEnd = (e: React.AnimationEvent<HTMLAnchorElement>) => {
    if (e.animationName === "fadeout") {
      setHasFinishedFadingOut(true);
    }
  };

  return <div className="flex gap">
    <VatNumberDetailsCard euVatNumber={euVatNumber} displayDot={props.displayDot} />

    {canRefresh && <div>
      <a onClick={refresh} className={reloadClasses} onAnimationEnd={onAnimationEnd} />
    </div>}
  </div>;
};

export default VatNumberDetails;